import { createReducer, on } from '@ngrx/store';
import * as fromRegistrationActions from './registration.actions';
import { RegistrationResult } from '@qvs/core';

export const registrationFeatureKey = 'registration';

export interface State {
  registrationResult: RegistrationResult;
  isLoading: boolean;
  isRegisteringInProgress: boolean;
  hasError: boolean;
}

export const initialState: State = {
  registrationResult: {
    isRegistered: false
  },
  isLoading: false,
  isRegisteringInProgress: false,
  hasError: false
};

export const reducer = createReducer(
  initialState,
  on(fromRegistrationActions.initiateRegistration, (state) => ({
    ...state,
    registrationResult: {
      isRegistered: false
    },
    isLoading: true,
    isRegisteringInProgress: false,
    hasError: false
  })),
  on(fromRegistrationActions.initiateRegistrationSuccess, (state, { registration }) => ({
    ...state,
    registrationResult: registration,
    isLoading: false,
    isRegisteringInProgress: true,
    hasError: false
  })),
  on(fromRegistrationActions.initiateRegistrationFailure, (state, { registrationResult, error }) => ({
    ...state,
    registrationResult,
    isLoading: false,
    isRegisteringInProgress: false,
    hasError: error
  })),
  on(fromRegistrationActions.registrationAccepted, (state) => ({
    ...state,
    isLoading: false,
    isRegisteringInProgress: false,
    hasError: false
  })),
  on(fromRegistrationActions.registrationRejected, (state, { registrationResult, error }) => ({
    ...state,
    registrationResult,
    isLoading: false,
    isRegisteringInProgress: false,
    hasError: error
  })),
  on(fromRegistrationActions.resetRegistration, () => initialState)
);
